<script lang="ts">
  import Editor from "$lib/components/Editor.svelte";
  import { onMount } from "svelte";

    onMount(() => {
        console.log("Admin test page mounted");
    });  
    
    let content = $state({ time: Date.now(), blocks: [] });
</script>

<h1>Test</h1>

<Editor bind:value={content} />